import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#E4E4E4',
    padding: 8,
    rotate: 90
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 24,
    marginBottom: 8,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: { margin: 'auto', flexDirection: 'row' },
  tableCol: {
    width: "16.6%",
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: 'center',
    padding: 8,
  },
});


const getStatus = (task) => {
  const status = task.status;

  return status === "doing"
    ? "Em execução"
    : status === "pending"
      ? "Pendente"
      : status === "done"
        ? "Concluído"
        : status === "doneLate"
          ? "Concluído com atraso"
          : "Atrasado";
};




const TasksPDF = ({ jobs }) => {

  // const usernames = jobs.map(item => item.accountable ?
  //   `${item.accountable.username.split(' ')[0]} ${item.accountable.username.split(' ')[1][0]}.` : "-");
  const usernames = jobs.map(item => item.accountable ?
    `${item.accountable.username}` : "-");

  const numberOfDays = (item) => item.duration.number === 24 ?
    item.duration.number / 24 + ' dia' :
    item.duration.number / 24 + ' dias';

  return (

    <Page size="A2" style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.title}>Tarefas do Fluxo</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>Tarefa</Text>
            <Text style={styles.tableCol}>Data de Inicio</Text>
            <Text style={styles.tableCol}>Duração</Text>
            <Text style={styles.tableCol}>Data de Término</Text>
            <Text style={styles.tableCol}>Status</Text>
            <Text style={styles.tableCol}>Responsável</Text>
          </View>
          {
            jobs.map((item, i) =>
              item.type === 'task' ? (
                <View style={styles.tableRow} key={i}>
                  <Text style={styles.tableCol}>{item.label}</Text>
                  <Text style={styles.tableCol}>
                    {item.start.toLocaleString()}
                  </Text>
                  <Text style={styles.tableCol}>{numberOfDays(item)}</Text>
                  <Text style={styles.tableCol}>{item.end.toLocaleString()}</Text>
                  <Text style={styles.tableCol}>{getStatus(item)}</Text>
                  <Text style={styles.tableCol}>
                    {usernames[i]}
                  </Text>
                </View>
              ) : null
            )}
        </View>
      </View>
    </Page>

  );
};

export default TasksPDF;
